import { useMediaQuery } from 'react-responsive';

export const useIsMobile = () => {
  return useMediaQuery({ query: `(max-width: 760px)` });
};

export const useIsTablet = () => {
  return useMediaQuery({ minWidth: 761, maxWidth: 1000 });
};